<template>
  <PageWrap page-title="Retenidos">
    <b-row class="mb-4">
      <b-col md="5" lg="4" xl="3">
        <BfInput
          :value="filter.textSearch"
          label="Búsqueda"
          data-key="textSearch"
          placeholder="Buscar por número de encargo"
          suffix-icon="el-icon-search"
          :bottom-gutter="false"
          @update="updatePageFilter"
        />
      </b-col>

      <b-col class="d-flex">
        <BfCheckbox
          :value="showPendientes"
          label="Pendientes"
          data-key="showPendientes"
          :bottom-gutter="false"
          class="mr-5"
          @update="updateShowPendientes"
        />
        <BfCheckbox
          :value="filter.showResueltas"
          label="Resueltas"
          data-key="showResueltas"
          :bottom-gutter="false"
          class="mr-5"
          @update="updatePageFilter"
        />
        <BfCheckbox
          :value="filter.showCompletas"
          label="Cerradas"
          data-key="showCompletas"
          :bottom-gutter="false"
          @update="updatePageFilter"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData"/>

    <BfTable
      v-else
      :data="retenidos"
      :columns="tableColumns"
      stripe
      cell-class-name="tasaciones-small-cell"
      @row-click="tableRowClick"
    >
      <span
        slot="encargo_codigo"
        slot-scope="{row}"
        class="tasaciones-table-marker"
      >{{row.encargo_codigo}}</span>

      <span slot="encargo_numero" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.encargo_numero}}
      </span>

      <span slot="estaResuelta_texto" slot-scope="{row}" v-if="row.estaResuelta">Si</span>
    </BfTable>
  </PageWrap>
</template>

<script>
import qsBinder from '@holamundo.app/vue-router-qs-binder';
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { retainedsAPI } from '@/api';
import { debounce, get } from '@/utils';

const FILTER_PROPERTIES = {
  textSearch: undefined,
  showResueltas: undefined,
  showCompletas: undefined,
};

export default {
  name: 'RetainedsList',

  mixins: [
    qsBinder({
      dataKey: 'filter',
      data: ({ query }) =>
        Object.keys(FILTER_PROPERTIES).reduce((acc, key) => {
          const value = get(query, [key], FILTER_PROPERTIES[key]);

          const formattedValue = () => {
            switch (key) {
              case 'showResueltas':
              case 'showCompletas':
                return typeof value === 'string' ? value === 'true' : value;
              default:
                return value;
            }
          };

          return {
            ...acc,
            [key]: formattedValue(),
          };
        }, {}),
      didUpdate: ($this) => {
        $this.loadData();
      },
    }),
  ],

  props: {
    chargeNumber: {
      type: [Number, String],
    },
  },

  data() {
    return {
      loadingData: false,
      retenidos: [],
      showPendientes: true,
    };
  },

  created() {
    this.filter.showCompletas = 0; // entramos por defecto cargando pendientes
    if (this.chargeNumber && this.filter.textSearch !== this.chargeNumber) {
      this.updateQsData({
        textSearch: this.chargeNumber,
      });
    } else {
      this.loadData();
    }
  },

  methods: {
    updateShowPendientes() {
      if (this.showPendientes) {
        this.showPendientes = false;
        this.filter.showCompletas = '';
      } else {
        this.showPendientes = true;
        this.filter.showCompletas = 0;
      }
      this.loadData();
    },
    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data = [] },
        } = await retainedsAPI.getAll({
          search: this.filter.textSearch,
          completas: this.filter.showCompletas,
          resueltas: this.filter.showResueltas ? 1 : '',
        });

        this.retenidos = data;
      } catch ({ message = '' }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      } finally {
        this.loadingData = false;
      }
    },

    /* eslint-disable-next-line func-names */
    updatePageFilter: debounce(function({ key, value }) {
      this.showPendientes = false;
      this.filter.showCompletas = '';
      this.filter.showResueltas = '';
      this.updateQsData({
        [key]: value,
      });
    }, 350),

    tableRowClick({ row, column }) {
      if (column.property === 'encargo_numero') {
        router.push({ name: 'charge', params: { id: `${row.encargos_id}` } });
      }

      if (column.property === 'encargo_codigo') {
        router.push({ name: 'retenido', params: { id: `${row.id}` } });
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Cod',
          dataKey: 'encargo_codigo',
          width: 72,
          sortable: true,
        },
        {
          label: 'Cli',
          width: 60,
          dataKey: 'encargo_cliente_nombre',
        },
        {
          label: 'Nº Encargo',
          dataKey: 'encargo_numero',
          sortable: true,
          width: 90,
        },

        {
          label: 'Motivo',
          dataKey: 'motivo',
        },
        {
          label: 'Tas',
          dataKey: 'tasador_asignado_nombre',
          width: 50,
        },
        {
          label: 'Resu',
          dataKey: 'estaResuelta_texto',
          width: 50,

        },
        {
          label: 'Cerr',
          dataKey: 'estaCerrada_texto',
          width: 50,

        },
        /*    {
          label: 'Descripción',
          dataKey: 'comentarios',
          sortable: true,
        }, */
        /* {
          label: 'Creada',
          dataKey: 'creada_texto',
          sortable: true,
        },
        {
          label: 'Resuelta',
          dataKey: 'resuelta_texto',
          sortable: true,
          width: 120,
        },
        {
          label: 'Notificada',
          dataKey: 'notificada_texto',
          sortable: true,
          width: 120,
        }, */
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
